<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <p>Export list of accounts, portfolios, and MYOB details</p>
        <el-form
          ref="form"
          :model="form"
          size="small"
        >
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                class="float-right"
                @click.native="downloadCSV()"
              >
                Export
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Account Portfolio Export"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
      :is-direct-download="true"
    />
  </div>
</template>

<script>
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    Preview
  },
  data () {
    return {
      pageTitle: 'Account Portfolio',
      breadcrumb: {
        name: 'Account Portfolio',
        route: { name: 'reports-account-portfolio' }
      },
      form: {},
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    downloadCSV () {
      this.configuration = {
        report: 'AccountPortfolio',
        params: this.form
      }
      this.isShowPreview = true
    }
  }
}
</script>
